var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<h3 ng-if=\"$ctrl.destinationProducts.length > 1\" id=\"reservation-title\" style=\"text-transform: none !important\">{{ 'reservation_tickets.room_select' | i18next }}</h3> <div ng-if=\"$ctrl.destinationProducts.length > 1\" class=\"form-group row row-no-gutters\"> <div class=\"col-md-6 col-xs-12\"> <div class=\"select-fa-arrow default\"> <select ng-model=\"$ctrl.destinationProduct\" ng-options=\"destinationProduct as destinationProduct.ProductName for destinationProduct in $ctrl.destinationProducts\" ng-change=\"$ctrl.onDestinationProductChange()\"> </select> </div> </div> </div>";
var id1="winresDestinationProductSelect.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresDestinationProductSelect/winresDestinationProductSelect.html
// module id = 518
// module chunks = 2